import Icon from '../components/Icon';

const Weather34Colored = Icon(
  'weather-34-colored',
  <>
    <path
      fill="#D0D6CE"
      fillRule="evenodd"
      d="M4.58 16.145a3.5 3.5 0 0 1 6.534-1.362q.087-.005.177-.005a2.611 2.611 0 0 1 0 5.222H5.054a1.956 1.956 0 0 1-.473-3.855"
      clipRule="evenodd"
    />
    <path
      fill="#EDB326"
      d="M14.51 5.316a.75.75 0 0 1-.554-.905l.373-1.551a.75.75 0 0 1 1.458.35l-.373 1.552a.75.75 0 0 1-.904.554M9.051 3.693a.75.75 0 0 0-1.279.784l.835 1.363a.75.75 0 1 0 1.28-.783zM15.348 16.28a5.233 5.233 0 1 0-7.657-4.767q.18-.013.364-.013c1.57 0 2.98.708 3.91 1.824a4.15 4.15 0 0 1 3.383 2.956M19.27 13.09a.75.75 0 0 1 .905-.554l1.552.373a.75.75 0 0 1-.351 1.458l-1.552-.373a.75.75 0 0 1-.554-.905M3.726 9.352a.75.75 0 0 1 .904-.554l1.555.374a.75.75 0 1 1-.351 1.458l-1.555-.373a.75.75 0 0 1-.553-.905M16.37 17.08a.75.75 0 0 1 1.03.248l.834 1.36a.75.75 0 0 1-1.28.784l-.833-1.36a.75.75 0 0 1 .248-1.032M18.5 8.217a.75.75 0 0 1 .248-1.032l1.361-.833a.75.75 0 1 1 .783 1.28l-1.36.833a.75.75 0 0 1-1.032-.248"
    />
  </>
);

export default Weather34Colored;
